














































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./product-columns";
import adminColumns from "./admin-product-columns";
import _ from "lodash";
import EditImage from "./edit-image.vue";
import Util from "../../../lib/util";

class PageUserRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  categoryId: number;
  isClient: boolean = false;
  isProductMaster: boolean = false;
  productType: string;
  poProductType: string;
  brandId: number = 0;
}

@Component({
  components: {EditImage}
})
export default class Product extends mixins(ListMixin, AbpBase) {
  namespace = "product";
  spinShow: boolean = false;
  clients = [];
  categories = [];
  productTypes = [];
  poProductTypes = [];
  brands = [];
  editImageModalShow: boolean = false;

  showEditImageModel(product) {
    this.$store.commit('product/edit',product);
    this.editImageModalShow = true;
  }
  confirmSave() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.UpdateImage"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          var data = {
            id: this.$store.state.product.editProduct.id,
            thumbnailUrl: this.$store.state.product.editProduct.thumbnailUrlNew,
          }
          await this.$store.dispatch({
            type: "product/updateImage",
            data: data,
          });
          
          Util.showSuccessMsg(this, "Success.UpdateImage");
          this.spinShow = false;
          this.getpage();
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  isClient() {
    return !_.isNil(this.$store.state.session.client);
  }
  isTenant() {
    return !_.isNil(this.$store.state.session.tenant);
  }
  isAction() {
    return (
      this.hasPermission("Pages.UpdateProduct") ||
      this.hasPermission("Pages.DeleteProduct")
    );
  }
  get client() {
    return this.$store.state.session.client;
  }
  getProductTypes() {
    this.$store
      .dispatch({
        type: "product/getListProductTypesForSelect",
      })
      .then(() => {
        var types = this.$store.state.product.productTypes;
        types.unshift({
          code: AppConsts.allItemValue,
          description: this.L(AppConsts.All),
        });
        this.pagerequest.productType = types.length === 0 ? "" : types[0].code;
        this.productTypes = types;
      });
  }
  getPoProductTypes() {
    this.$store
      .dispatch({
        type: "product/getPoProductTypes",
      })
      .then((result) => {
        result.unshift({
          code: AppConsts.allItemValue,
          description: this.L(AppConsts.All),
        });
        this.pagerequest.poProductType =
          result.length === 0 ? "" : result[0].code;
        this.poProductTypes = result;
      });
  }
  getBrands() {
    this.$store
      .dispatch({
        type: "masterData/getBrands",
      })
      .then((result) => {
        result.unshift({
          id: 0,
          code: AppConsts.allItemValue,
          name: this.L(AppConsts.All),
        });
        this.pagerequest.brandId = result.length === 0 ? "" : result[0].id;
        this.brands = result;
      });
  }
  get clientCode() {
    return this.isClient() ? this.$store.state.session.client.code : null;
  }
  get store() {
    return this.$store.state.product;
  }
  importProducts() {
    this.$router.push({ path: "../grpclient/import-product" });
  }
  //filters
  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        if (!this.isClient()) {
          this.pagerequest.clientCode = re.length === 0 ? "" : re[0].code;
        }
        this.clients = re;
      });
  }
  async getCategories() {
    await this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: { hasAllItem: true, clientCode: this.pagerequest.clientCode },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        if (re.length > 0) {
          this.pagerequest.categoryId = re[0].id;
        }
        this.categories = re;
      });
  }

  async changeClientCode() {
    await this.getCategories();
  }

  createProduct() {
    this.$root.$router.push({ path: "create/product" });
  }
  viewProduct(id: string) {
    this.$root.$router.push({ name: "product/:id", params: { id: id } });
  }
  updateProduct(id: string) {
    this.$root.$router.push({ name: "update/product/:id", params: { id: id } });
  }
  get list() {
    var re = this.$store.state.product.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    //filters
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
      this.pagerequest.isClient = true;
    }
  }
  afterRemove() 
  {
    this.$Message.success("Xóa sản phẩm thành công");
    this.searchData();
  }
  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: "report/exportProducts",
      data: this.pagerequest,
    });
  }
  get columns() {
    return [
      ...(this.isClient() ? columns : columns.concat(adminColumns)),
      {
        title: this.L("Action"),
        slot: "action",
        fixed: "right",
        align: "center",
        width: 200,
      },
    ];
  }
  async created() {
    try {
      this.spinShow = true;
      await this.getClients();
      await this.getCategories();
      this.getPoProductTypes();
      this.getBrands();
      this.getProductTypes();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
